import type { AiCostLimitLevel } from '@Domain/AiCostLimits/AiCostLimitLevel';
import type { SubjectDimension } from '@UI/Pages/Administration/AiCosts/CostTabs/SubjectCosts/Helpers/subjectDimensionLabels';

/** The level of the limit a row of each axis can carry; the account level has no row. */
const subjectLimitLevels: Readonly<Record<SubjectDimension, Exclude<AiCostLimitLevel, 'account'>>> =
	Object.freeze({
		facilities: 'facility',
		organizations: 'organization',
		users: 'user',
	});

export default subjectLimitLevels;
